import { render } from "@/web/pages/habitaciones/EditHabitacion.html?vue&type=template&id=760279f6"
import script from "@/web/ts/controllers/habitacion/editHabitacion.ts?vue&type=script&lang=js"
export * from "@/web/ts/controllers/habitacion/editHabitacion.ts?vue&type=script&lang=js"

import "@/web/css/custom.css?vue&type=style&index=0&lang=css"

import exportComponent from "E:\\RESPALDO 17-01-26 PC\\git\\adminSanatorio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__